import { AddressBookEntry } from "@api/graphql/generated/generated-types";

export type Prediction = {
  googleAutocompletePrediction: google.maps.places.AutocompletePrediction;
  addressBookEntry?: AddressBookEntry;
};

type BuildAddressPredictionsInput = {
  googlePredictions: google.maps.places.AutocompletePrediction[];
  addressBookEntries: AddressBookEntry[];
  shouldReverseAddressSearch: boolean;
};

export function buildAddressPredictions({
  googlePredictions,
  addressBookEntries,
  shouldReverseAddressSearch,
}: BuildAddressPredictionsInput): Prediction[] {
  if (!shouldReverseAddressSearch) {
    return googlePredictions.map((prediction) => ({
      googleAutocompletePrediction: prediction,
    }));
  }

  const entriesByPlaceId: Record<string, AddressBookEntry[]> = {};
  for (const entry of addressBookEntries) {
    const placeId = entry.location?.googlePlaceId;
    if (!placeId) {
      continue;
    }
    if (!entriesByPlaceId[placeId]) {
      entriesByPlaceId[placeId] = [entry];
    } else {
      entriesByPlaceId[placeId].push(entry);
    }
  }

  return googlePredictions.flatMap((prediction) => {
    const entries = entriesByPlaceId[prediction.place_id];
    if (!entries || entries.length === 0) {
      return [{ googleAutocompletePrediction: prediction }];
    }
    return [
      ...entries.map((entry) => ({
        googleAutocompletePrediction: prediction,
        addressBookEntry: entry,
      })),
      { googleAutocompletePrediction: prediction },
    ];
  });
}
